import React from 'react';
import { Check, Plus, Trash2 } from 'lucide-react';

/**
 * Reusable Industry Selection Grid Component
 * Displays industries in a grid with selection capability
 */
const IndustryGrid = ({ 
  industries, 
  selectedIndustries = [],
  onToggle,
  disabledIndustries = [],
  currentIndustries = [],
  columns = 3
}) => {
  const addedIndustries = selectedIndustries.filter(
    i => !currentIndustries.includes(i)
  );
  const removedIndustries = currentIndustries.filter(
    i => !selectedIndustries.includes(i)
  );

  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4'
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-2`}>
      {industries.map(industry => {
        const isSelected = selectedIndustries.includes(industry);
        const isDisabled = disabledIndustries.includes(industry);
        const wasAdded = addedIndustries.includes(industry);
        const wasRemoved = removedIndustries.includes(industry);
        
        return (
          <button
            key={industry}
            onClick={() => !isDisabled && onToggle(industry)}
            disabled={isDisabled}
            className={`px-3 py-2 rounded-lg border-2 text-sm font-medium transition-all ${
              isDisabled
                ? 'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed'
                : isSelected
                  ? wasAdded
                    ? 'border-green-500 bg-green-50 text-green-900'
                    : 'border-indigo-500 bg-indigo-50 text-indigo-900'
                  : wasRemoved
                    ? 'border-red-200 bg-red-50 text-red-700'
                    : 'border-gray-200 bg-white text-gray-700 hover:border-indigo-300'
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="truncate">{industry}</span>
              {isSelected && <Check className="h-4 w-4 flex-shrink-0" />}
              {wasAdded && <Plus className="h-3 w-3 text-green-600 flex-shrink-0" />}
              {wasRemoved && <Trash2 className="h-3 w-3 text-red-600 flex-shrink-0" />}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default IndustryGrid;
